module.exports = __webpack_public_path__ + "img/folder-open.83c1cefa.svg";